import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'ps-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  public role: any;
  public forgotPasswordForm: any;
  public ischangePasswordFormSubmitted!: boolean;
  public changePasswordForm: any;
  public email: any;
  public spinner: boolean = false;

  constructor(private fb: FormBuilder, private authService: AuthService, private toastr: ToastrService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.role = localStorage.getItem('role');
    this.email = localStorage.getItem("email")
    // localStorage.clear();
    this.initialisechangePasswordForm();
  }

  // initialiseforgotpasswordform
  initialisechangePasswordForm() {
    this.changePasswordForm = this.fb.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required]]
    })
  }

  onSubmit() {
    this.ischangePasswordFormSubmitted = true;
    if (this.changePasswordForm.valid) {
      if (this.changePasswordForm.value.newPassword == this.changePasswordForm.value.oldPassword) {
        this.toastr.error("New password should not be as old password")
      }
      else {
        var data = {
          "oldPassword": this.changePasswordForm.controls['oldPassword'].value,
          "newPassword": this.changePasswordForm.controls['newPassword'].value,
          "email": this.email
        }
        this.spinner = true;
        this.authService.changePassword(data).subscribe(res => {
          if (res.status) {
            this.spinner = false;
            this.toastr.success("Password Change Successfully!")
            this.changePasswordForm.reset();
            this.navigateBasedOnRole();
            this.router.navigate(["/auth/login"]);
          }
          else {
            this.spinner = false;
            this.toastr.error("Password Not Changed!");
          }
        })
      }
    }
  }

  /*6.Navigate Based on Role*/
  navigateBasedOnRole() {
    var role = localStorage.getItem('role')
    if (role == "PORTAL_ADMIN") {
      this.router.navigate(["/admin/institute"]);
    }
    else if (role == "PORTAL_SPOC") {
      this.router.navigate(["/spoc/spoc-institute"]);
    }
    else if (role == "PORTAL_MENTOR") {
      this.router.navigate(["/mentor/mentor-details"]);
    }
    else if (role == " PORTAL_INSTITUTION") {
      this.router.navigate(["/institute/institute-profile"]);
    }
  }
  back() {
    this.router.navigate(["/auth/login"]);
  }
}


